import { createSelector } from 'reselect'

export const getCartItemLoading = createSelector(
  (state) => state && state.cart && state.cart.cartItemLoading,
  cartItemLoading => cartItemLoading
)
